import React from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/navbar/Navbar";
import Footer from "./components/Footer/Footer";
//Context
import Collection from "./components/Collections/Collection";
import Login from "./components/Account/Login";
import ProductPage from "./components/product page/ProductPage";
import MainPage from "./components/MainPage";
import NotFound from "./components/404 Page/NotFound";
import OurValues from "./Pages/OurValues";
import BlogLanding from "./components/blogs/BlogLanding";
import Blog from "./components/blogs/Blog";
import ContactUs from "./components/contactUs/contactUs";
import FAQ from "./Pages/Faq";

function App() {
  return (
    <>
      <Router>
        <Navbar />
        <Routes>
          <Route exact path="/" element={<MainPage />}></Route>
          <Route
            exact
            path="/collection/:name"
            element={<Collection />}
          ></Route>
          <Route exact path="/products/:name" element={<ProductPage />}></Route>
          <Route path={`/login`} element={<Login />}></Route>
          <Route path={`/pages/our-values`} element={<OurValues />}></Route>
          <Route path={`/pages/privacy-policy`} element={<OurValues />}></Route>
          <Route path={`/pages/terms`} element={<OurValues />}></Route>
          <Route path={`/pages/disclaimer`} element={<OurValues />}></Route>
          <Route
            path={`/pages/return-refund-policy`}
            element={<OurValues />}
          ></Route>
          <Route
            path={`/pages/corporate-information`}
            element={<OurValues />}
          ></Route>
          <Route
            path={`/pages/return-refund-policy`}
            element={<OurValues />}
          ></Route>

          <Route path={`/pages/blogs`} element={<BlogLanding />}></Route>
          <Route path={`/pages/blogs/:name`} element={<Blog />}></Route>
          <Route path={`/pages/get-in-touch`} element={<ContactUs />}></Route>
          <Route path={`/pages/faqs`} element={<FAQ />}></Route>

          <Route path="*" element={<NotFound />}></Route>
        </Routes>
        <Footer />
      </Router>
    </>
  );
}

export default App;
